export default __webpack_public_path__ + "static/media/Privacy.e2ec6bd1.png";